import React from 'react'

interface ContainerProps {
  children: React.ReactNode
  header?: React.ReactNode
  footer?: React.ReactNode
  className?: string
}

export const Container: React.FC<ContainerProps> = ({ children, header, footer }) => {
  return (
    <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', backgroundColor: 'white' }}>
      {header && <div style={{ padding: '16px', borderBottom: '1px solid #e0e0e0', fontWeight: 'bold' }}>{header}</div>}
      <div style={{ padding: '16px' }}>{children}</div>
      {footer && <div style={{ padding: '16px', borderTop: '1px solid #e0e0e0' }}>{footer}</div>}
    </div>
  )
}
